
// 회원정보 선택값 리스트-----------------
//키 리스트
export const heightList = [{txt:"149cm 이하",val:["0","149"]},{txt:"150cm ~ 154cm",val:["150","154"]},{txt:"155cm ~ 159cm",val:["155","159"]},{txt:"160cm ~ 164cm",val:["160","164"]},{txt:"165cm ~ 169cm",val:["165","169"]},{txt:"170cm ~ 174cm",val:["170","174"]},{txt:"175cm ~ 179cm",val:["175","179"]},{txt:"180cm ~ 184cm",val:["180","184"]},{txt:"185cm ~ 189cm",val:["185","189"]},{txt:"190cm ~ 194cm",val:["190","194"]},{txt:"195cm ~ 200cm",val:["195","200"]}];

//외모점수 리스트
export const visualList = ["1","2","3","4","5"];

//MBTI 리스트
export const mbtiList = ["ISTP","ISTJ","ISFP","ISFJ","INTP","INTJ","INFP","INFJ","ESTP","ESTJ","ESFP","ESFJ","ENTP","ENTJ","ENFP","ENFJ"];

//흡연 리스트
export const smokList = [{txt:"한다",val:"1"},{txt:"가끔 한다",val:"3"},{txt:"안 한다",val:"2"}];

//음주 리스트
export const drinkList = [{txt:"한다",val:"1"},{txt:"가끔 한다",val:"2"},{txt:"안 한다",val:"3"}];